/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Container from 'blocks/Container/Container';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';

const StyledContainer = styled(Container)`
  margin-top: 125px;
  padding: 0 20px;
`;

@inject("coreStore")
@observer
export default class PrivacyPolicy extends Component {
  render() {
    const { coreStore: { translations } } = this.props;
    return (
      <StyledContainer dangerouslySetInnerHTML={{ __html: translations.PRIVACY_POLICY }} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/PrivacyPolicy/index.jsx